import {CdMdsQuestionFactory} from './cd-mds-question-factory';
import {CdMdsArea} from '../../../interfaces/care/cd-rai/cd-mds-area';
import {CdMdsQuestion} from '../../../interfaces/care/cd-rai/cd-mds-question';

export class CdMdsAreaFactory {

  /**
   *
   * @param caMdsArea
   */
  public static fromObject(caMdsArea: any): CdMdsArea {
      return new class implements CdMdsArea {
        cdMdsQuestions: CdMdsQuestion[] =
          caMdsArea.c_mds_questions ? CdMdsQuestionFactory.fromArray(caMdsArea.c_mds_questions) : [];
        id: number = caMdsArea.id;
        name: string = caMdsArea.name;
        description: string = caMdsArea.description;
      };
  }

  /**
   *
   * @param caMdsAreas
   */
  public static fromArray(caMdsAreas: any[]): CdMdsArea[] {
    return caMdsAreas.map(_caMdsArea => CdMdsAreaFactory.fromObject(_caMdsArea));
  }

}
